import { MediaCommandModel } from './media-command.model';
import { MediaFileAssociationCommandModel } from './media-fileassociation';

export class MediaLibraryCommandModel {
    public mediaCommand: MediaCommandModel[];
    public mediaFileAssociationCommand: MediaFileAssociationCommandModel[];
}